module.exports = __webpack_public_path__ + "static/media/Visa.7f02592c.gif";